module.exports = __webpack_public_path__ + "img/success-symbol.979b02f4.svg";